import { Checkbox, Col, Collapse, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import { hasValueInList } from '../../../../helpers/array';
import { LabelCheckbox } from '../styles';

const { Panel } = Collapse;

export default function Acessos({
  permissoesExistentes,
  selectedPermissions,
  onSelectPermission,
  isDisabled,
}) {
  return (
    <>
      {Object.keys(permissoesExistentes).map(tela => (
        <Col className="padding" span={24} key={tela}>
          <Collapse bordered={false}>
            <Panel header={tela} key="1">
              <Row>
                {permissoesExistentes[tela].map(({ id, name }) => (
                  <Col xs={24} sm={9} md={9} lg={8} xl={6} key={id}>
                    <Checkbox
                      value={id}
                      checked={hasValueInList(selectedPermissions, 'id', id)}
                      onChange={() => onSelectPermission(id)}
                      disabled={isDisabled}
                    >
                      <LabelCheckbox>{name}</LabelCheckbox>
                    </Checkbox>
                  </Col>
                ))}
              </Row>
            </Panel>
          </Collapse>
        </Col>
      ))}
    </>
  );
}

Acessos.propTypes = {
  permissoesExistentes: PropTypes.instanceOf(Object).isRequired,
  selectedPermissions: PropTypes.instanceOf(Array).isRequired,
  onSelectPermission: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
};

Acessos.defaultProps = {
  isDisabled: false,
};
